import React from "react";
import { Link } from "react-router-dom";
import { Icon } from "../Icon";
import { WEBSITE_SERVICE as W } from "../content";
import { CtaBand, FlowLine, PageHero, SectionHead, useSeo } from "../ui";

const contactTo = `/contact?type=${encodeURIComponent(W.inquiryType)}`;

function Checks({ items }) {
  return (
    <ul className="checklist">
      {items.map((t) => (
        <li key={t}>
          <Icon.Check width="15" height="15" aria-hidden="true" focusable="false" />
          <span>{t}</span>
        </li>
      ))}
    </ul>
  );
}

export default function WebsiteService() {
  useSeo({
    title: "웹사이트 개발 서비스 — 자영업자 홈페이지 빠른 구축, 기본료 20만원부터 | I.META",
    description:
      "식당 · 카페 · 미용실 · 공방 · 학원 등 소상공인 · 자영업자 홈페이지를 빠르게 구축합니다. 휴대폰 화면, 메뉴 · 가격, 위치 지도, 전화 · 카카오톡 연결. 기본료 20만원부터. 광주 웹사이트 제작 I.META.",
    path: "/services/website",
  });

  return (
    <>
      <PageHero kicker="웹사이트 개발 서비스" title={W.headline} desc={W.lead}>
        <div className="price-tag">
          <strong>{W.price}</strong>
          <span>{W.priceNote}</span>
        </div>
        <div className="hero__actions">
          <Link to={contactTo} className="btn btn--primary">
            홈페이지 제작 문의 <Icon.ArrowRight width="16" height="16" aria-hidden="true" focusable="false" />
          </Link>
        </div>
      </PageHero>

      <section className="section section--tight">
        <SectionHead kicker="FOR" title="이런 가게를 위한 서비스입니다" />
        <ul className="roles__list who-chips">
          {W.who.map((w) => <li key={w}>{w}</li>)}
        </ul>
      </section>

      <section className="section">
        <div className="grid grid--2 fund-cols">
          <div className="contact__panel">
            <h2 className="contact__panel-title">홈페이지에 담을 수 있는 것</h2>
            <Checks items={W.features} />
          </div>
          <div className="contact__panel">
            <h2 className="contact__panel-title">필요하면 더할 수 있는 것</h2>
            <Checks items={W.extras} />
            <p className="contact__panel-note">{W.priceNote}</p>
          </div>
        </div>
      </section>

      <section className="section">
        <SectionHead kicker="FLOW" title="진행 순서" />
        <FlowLine items={W.flow} numbered />
        <p className="note-line">
          자영업 매장을 위한 제작 경험이 있습니다. <Link to={W.reference.to}>{W.reference.label}</Link>
        </p>
      </section>

      <CtaBand
        title={W.headline}
        desc={W.price}
        to={contactTo}
        label="홈페이지 제작 문의"
      />
    </>
  );
}
